import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromBlog from './blog.reducer';
import * as fromRoot from '../../reducers';

export interface BlogState {
  blog: fromBlog.State;
}

export interface State extends fromRoot.State {
  blog: BlogState;
}

export const reducers = {
  blog: fromBlog.reducer,
};

export const getBlogsState = createFeatureSelector<BlogState>('blog');

export const getBlogState = createSelector(
  getBlogsState,
  state => state.blog
);

export const selectAllBlogListings = createSelector(
  getBlogState,
  fromBlog.getAllBlogListingsEntities
);
export const selectIsBlogInfoValid = createSelector(
  getBlogState,
  fromBlog.getIsBlogInfoValidEntities
);
export const selectIsBlogListingValid = createSelector(
  getBlogState,
  fromBlog.getIsBlogListingValidEntities
);
export const selectBlogCategories = createSelector(
  getBlogState,
  fromBlog.getBlogCategoryEntities
);
export const selectBlogListing = createSelector(
  getBlogState,
  fromBlog.getBlogListingEntities
);
export const selectBlogTags = createSelector(
  getBlogState,
  fromBlog.getBlogTagsEntities
);
export const selectBlogIsLoading = createSelector(
  getBlogState,
  fromBlog.getBlogIsLoadingEntities
);
export const selectIsCreateSuccess = createSelector(
  getBlogState,
  fromBlog.getIsCreateSuccess
);
export const selectIsUpdateSuccess = createSelector(
  getBlogState,
  fromBlog.getIsUpdateSuccess
);
export const selectError = createSelector(
  getBlogState,
  fromBlog.getError
);
